var staticDayTime = require('./staticDayTime')

var staticWeekTime = staticDayTime * 7

module.exports = staticWeekTime



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticWeekTime.js
// module id = 469
// module chunks = 75